export default __webpack_public_path__ + "static/media/laconic_small@2x.1c54a2fb.jpg";